import { GCP_GSD_LIMIT_CM } from "./gcpMarkerRule";

/** 고도 표의 단위(m) — 이 단위로 내리므로, 표의 고도로 날면 GSD 가 상한을 넘지 않는다. */
const ALTITUDE_STEP_M = 5;

/**
 * 고도 표의 렌즈. `focalCentrePx` 는 자동 구축 게이트가 렌즈마다 두는 초점거리(px)의 기준값이라, 게이트와 같은 값이어야 한다 —
 * 게이트가 렌즈를 더하거나 값을 바꾸면 여기도 고친다. 게이트가 중심을 모르는 렌즈(P1 24 mm 등)는 늘 담당자 경로로 넘어가므로
 * 두지 않는다(mapping-request 「자동 인식 가이드의 고도 표」).
 */
const GUIDE_ALTITUDE_LENSES = [
  { id: "m3e", focalCentrePx: 3725.15 },
  { id: "p4rtk", focalCentrePx: 3666.67 },
  { id: "p1_35", focalCentrePx: 8199.22, validatedMaxAltitudeM: 110 },
] as const;

/** 고도 표의 행 — GSD 상한이 되는 고도를 5 m 단위로 내리되, 자동 구축이 검증한 비행고도를 넘겨 적지 않는다. */
export const GUIDE_ALTITUDE_ROWS = GUIDE_ALTITUDE_LENSES.map((lens) => {
  const steppedM =
    Math.floor(
      ((GCP_GSD_LIMIT_CM / 100) * lens.focalCentrePx) / ALTITUDE_STEP_M
    ) * ALTITUDE_STEP_M;
  const validatedMaxM =
    "validatedMaxAltitudeM" in lens ? lens.validatedMaxAltitudeM : Infinity;
  return {
    id: lens.id,
    altitudeM: Math.min(steppedM, validatedMaxM),
    isCappedByValidatedRange: steppedM > validatedMaxM,
  };
});
